<template>
  <div class="review-contract">
    <el-row :gutter="24">
      <!-- 左侧列表 -->
      <el-col :span="8">
        <div class="list-card" v-loading="loading">
          <div class="card-header">
            <div class="filter-buttons">
              <el-radio-group v-model="listType" size="small" @change="handleTypeChange">
                <el-radio-button label="public">大厅</el-radio-button>
                <el-radio-button label="mine">我的</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="list-content">
            <div v-for="item in contractList" 
                 :key="item.id"
                 class="list-item"
                 :class="{ active: activeItem === item.id }"
                 @click="handleItemClick(item)">
              <div class="item-header">
                <div class="item-title">{{ item.name }}</div>
                <el-tag size="small" type="info" v-if="item.status == '1' && item.lawyerid != 0">
                   进行中
                </el-tag>
                <el-tag size="small" type="success" v-if="item.status == '2' && item.lawyerid != 0">
                   已完成
                </el-tag>
                
              </div>
              <div class="item-info">
                <span>委托人：UID{{ item.uid }}</span>
                <span>{{ item.time }}</span>
              </div>
            </div>
            
            <!-- 分页器 -->
            <div class="pagination-container">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageParams.page"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageParams.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 右侧详情 -->
      <el-col :span="16">
        <div class="detail-card" v-loading="detailLoading">
          <div class="card-header">
            合同详情
            <div class="header-actions" v-if="currentDetail && currentDetail.status == '1' && currentDetail.lawyerid == 0">
              <el-button type="primary" 
                        size="small" 
                        @click="handleApprove"
                        :loading="submitting">
                接单
              </el-button>
              <!-- <el-button type="danger" 
                        size="small" 
                        @click="handleReject"
                        :loading="submitting">
                驳回
              </el-button> -->
            </div>
          </div>
          <div class="detail-content" v-if="currentDetail">
            <!-- 合同详情内容 -->
            <div class="detail-section">
              <h3>基本信息</h3>
              <div class="info-item">
                <span class="label">委托人：</span>
                <span>UID{{ currentDetail.uid }}</span>
              </div>
              <div class="info-item">
                <span class="label">订单号：</span>
                <span>{{ currentDetail.id }}</span>
              </div>
              <div class="info-item">
                <span class="label">下单时间：</span>
                <span>{{ currentDetail.time }}</span>
              </div>
              <div class="info-item" v-if="currentDetail.lawyerid != 0">
                <span class="label">审核律师：</span>
                <span>{{ currentDetail.lawyer }}</span>
              </div>
              <div class="info-item" v-if="currentDetail.lawyerid != 0">
                <span class="label">接单时间：</span>
                <span>{{ currentDetail.gettime }}</span>
              </div>
              <div class="info-item" v-if="currentDetail.status == '2'">
                <span class="label">完成时间：</span>
                <span>{{ currentDetail.dotime }}</span>
              </div>
            </div>

            <!-- 合同内容预览 -->
            <div class="detail-section">
              <h3>合同内容</h3>
              <el-input
                v-model="currentDetail.content"
                type="textarea"
                :rows="25"
                
                class="contract-content">
              </el-input>
              
              <!-- 合同附件 -->
              <div class="contract-file" v-if="currentDetail.fileurl">
                <h4>合同附件</h4>
                <a :href="currentDetail.fileurl" target="_blank">
                 下载
                </a>
              </div>
            </div>

            <!-- 审核意见 -->
            <div class="detail-section" v-if=" currentDetail.lawyerid != 0">
              <h3>审核意见</h3>
              <el-input
                v-model="currentDetail.reply"
                type="textarea"
                :rows="5"
                placeholder="请输入审核意见">
              </el-input>
              <!-- 添加提交按钮 -->
              <div class="submit-button">
                <el-button 
                  type="primary" 
                  @click="handleSubmitReview"
                  :loading="submitting">
                  提交审核
                </el-button>
              </div>
            </div>

            <!-- 显示历史审核意见 -->
            <!-- <div class="detail-section" v-if="currentDetail.status != '1' && currentDetail.comment">
              <h3>审核结果</h3>
              <div class="review-result">
                <el-tag size="medium" 
                        :type="currentDetail.status == '2' ? 'success' : 'danger'"
                        style="margin-bottom: 8px">
                  {{ currentDetail.status == '2' ? '审核通过' : '审核驳回' }}
                </el-tag>
                <div class="comment">{{ currentDetail.comment }}</div>
              </div>
            </div> -->
          </div>
          <div class="empty-detail" v-else>
            请选择左侧合同查看详情
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import contractApi from '@/api/contract'

export default {
  name: 'ReviewContract',
  data() {
    return {
      listType: 'public',
      loading: false,
      detailLoading: false,
      submitting: false,
      activeItem: null,
      contractList: [],
      currentDetail: null,
      reviewComment: '',
      pageParams: {
        page: 1,
        pageSize: 10
      },
      total: 0
    }
  },
  created() {
    this.fetchContractList()
  },
  methods: {
    // 获取合同列表
    async fetchContractList() {
      try {
        this.loading = true
        const res = await contractApi.getReviewList({
          ...this.pageParams,
          type: this.listType
        })
        if (res.status === 200) {
          this.contractList = res.data.list
          this.total = res.data.total
        }
      } catch (error) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },

    // 获取合同详情
    async handleItemClick(item) {
      this.activeItem = item.id
      this.reviewComment = ''
      try {
        this.detailLoading = true
        const res = await contractApi.getReviewDetail({ id: item.id })
        if (res.status === 200) {
          this.currentDetail = res.data
        }
      } catch (error) {
        this.$message.error('获取详情失败')
      } finally {
        this.detailLoading = false
      }
    },

    // 切换列表类型
    handleTypeChange() {
      this.pageParams.page = 1
      this.activeItem = null
      this.currentDetail = null
      this.fetchContractList()
    },

    // 分页处理
    handleSizeChange(val) {
      this.pageParams.pageSize = val
      this.pageParams.page = 1
      this.fetchContractList()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.fetchContractList()
    },

    // 接单
    async handleApprove() {
     
      try {
        await this.$confirm('确定接单此合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        console.log(this.currentDetail)
        this.submitting = true
        const res = await contractApi.pcgetshtorder({
          id: this.currentDetail.id,
        })
        
        if (res.status === 200) {
          if(res.data.st === 2){
            this.$message.error('该订单已有人接单')
            await this.fetchContractList()
            this.currentDetail = null
            return
          }

          this.$message.success('接单成功')
          await this.fetchContractList()
          await this.handleItemClick(this.currentDetail)
        }
        // if(res.status === 400){
        //   this.$message.error(res.msg)
        //   await this.fetchContractList()
        //   this.currentDetail = null
        // }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('操作失败')

        }
      } finally {
        this.submitting = false
      }
    },

    // 审核驳回
    async handleReject() {
      if (!this.reviewComment.trim()) {
        this.$message.warning('请输入审核意见')
        return
      }

      try {
        await this.$confirm('确定驳回此合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        this.submitting = true
        const res = await contractApi.reviewContract({
          id: this.currentDetail.id,
          status: 3,
          comment: this.reviewComment
        })
        
        if (res.status === 200) {
          this.$message.success('已驳回')
          await this.fetchContractList()
          await this.handleItemClick(this.currentDetail)
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('操作失败')
        }
      } finally {
        this.submitting = false
      }
    },

    // 提交审核意见
    async handleSubmitReview() {
      if (!this.currentDetail.reply.trim()) {
        this.$message.warning('请输入审核意见')
        return
      }

      try {
        await this.$confirm('确定提交审核意见吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        this.submitting = true
        const res = await contractApi.reviewContract({
          id: this.currentDetail.id,
          reply: this.currentDetail.reply
        })
        
        if (res.status === 200) {
          this.$message.success('提交成功')
          await this.fetchContractList()
          await this.handleItemClick(this.currentDetail)
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('提交失败')
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.review-contract {
  .list-card,
  .detail-card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    height: calc(100vh - 230px);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .card-header {
      padding: 16px;
      font-weight: 500;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-actions {
        .el-button + .el-button {
          margin-left: 8px;
        }
      }
    }
  }

  .list-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 16px;

    .list-item {
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #f5f5f5;
      }

      &.active {
        background: #e6f7ff;
      }

      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .item-title {
          font-weight: 500;
          color: #262626;
        }
      }

      .item-info {
        font-size: 13px;
        color: #8c8c8c;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .detail-content {
    padding: 20px;
    height: calc(100% - 57px);
    overflow-y: auto;

    .detail-section {
      margin-bottom: 24px;

      h3 {
        font-size: 16px;
        margin: 0 0 16px 0;
        color: #262626;
      }

      .info-item {
        margin-bottom: 12px;
        line-height: 1.5;
        color: #333;

        .label {
          color: #8c8c8c;
          margin-right: 8px;
        }
      }

      .contract-content {
        :deep(.el-textarea__inner) {
          color: #254076;
        }
      }

      .submit-button {
        margin-top: 16px;
        text-align: right;
      }
    }
  }

  .empty-detail {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8c8c8c;
  }

  .pagination-container {
    padding: 16px;
    text-align: center;
    background: #fff;
    border-top: 1px solid #f0f0f0;
  }

  .filter-buttons {
    .el-radio-group {
      display: flex;
      :deep(.el-radio-button__inner) {
        border-radius: 0;
      }
      :deep(.el-radio-button:first-child .el-radio-button__inner) {
        border-radius: 4px 0 0 4px;
      }
      :deep(.el-radio-button:last-child .el-radio-button__inner) {
        border-radius: 0 4px 4px 0;
      }
    }
  }

  // 审核相关样式
  .contract-file {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;

    h4 {
      font-size: 14px;
      margin: 0 0 8px 0;
      color: #262626;
    }

    a {
      color: #1890ff;
      text-decoration: none;

      &:hover {
        color: #40a9ff;
      }
    }
  }

  .review-result {
    .comment {
      margin-top: 8px;
      padding: 12px;
      background: #fafafa;
      border: 1px solid #f0f0f0;
      border-radius: 4px;
      color: #666;
      line-height: 1.5;
    }
  }
}

</style> 